export const BADGES = [

  { id: 'ball', src: '/assets/event_pics/ball.webp' },
  { id: 'beach', src: '/assets/event_pics/beach.webp' },
  { id: 'book', src: '/assets/event_pics/book.webp' },
  { id: 'cafe', src: '/assets/event_pics/cafe.webp' },
  { id: 'cards', src: '/assets/event_pics/cards.webp' },
  { id: 'dinner', src: '/assets/event_pics/dinner.webp' },
  { id: 'fitness', src: '/assets/event_pics/fitness.webp' },
  { id: 'gym', src: '/assets/event_pics/gym.webp' },
  { id: 'home', src: '/assets/event_pics/home.webp' },
  { id: 'house', src: '/assets/event_pics/house.webp' },
  { id: 'language', src: '/assets/event_pics/language.webp' },
  { id: 'nature', src: '/assets/event_pics/nature.webp' },
  { id: 'night-club', src: '/assets/event_pics/night-club.webp' },
  { id: 'people_table2', src: '/assets/event_pics/people_table2.webp' },
  { id: 'people-table', src: '/assets/event_pics/people-table.webp' },
  { id: 'picture', src: '/assets/event_pics/picture.webp' },
  { id: 'planet', src: '/assets/event_pics/planet.webp' },
  { id: 'donut', src: '/assets/event_pics/donut.webp' },
  { id: 'astronaut', src: '/assets/event_pics/astronaut.webp' },
  { id: 'running', src: '/assets/event_pics/running.webp' },
  { id: 'sputnik', src: '/assets/event_pics/sputnik.webp' },
  { id: 'stretching', src: '/assets/event_pics/stretching.webp' },
  { id: 'teacher', src: '/assets/event_pics/teacher.webp' },
  { id: 'wave', src: '/assets/event_pics/wave.webp' },
  { id: 'woman', src: '/assets/event_pics/woman.webp' },
  { id: 'yoga', src: '/assets/event_pics/yoga.webp' },


  { id: 'board-games', src: '/assets/event_pics/board-games.webp' },
  { id: 'christmas', src: '/assets/event_pics/christmas.webp' },
  { id: 'christmas-market', src: '/assets/event_pics/christmas-market.webp' },
  { id: 'entertainment', src: '/assets/event_pics/entertainment.webp' },
  { id: 'entertainment-party', src: '/assets/event_pics/entertainment_party.webp' },
  { id: 'hiking', src: '/assets/event_pics/hiking.webp' },
  { id: 'hills', src: '/assets/event_pics/hills.webp' },
  { id: 'meetup', src: '/assets/event_pics/meetup.webp' },
  { id: 'nature-forest', src: '/assets/event_pics/nature_forest.webp' },
  { id: 'networking', src: '/assets/event_pics/networking.webp' },
  { id: 'networking-tables', src: '/assets/event_pics/networking_tables.webp' },
  { id: 'party', src: '/assets/event_pics/party.webp' },
  { id: 'ping-pong', src: '/assets/event_pics/ping-pong.webp' },
  { id: 'question', src: '/assets/event_pics/question.webp' },
  { id: 'sport', src: '/assets/event_pics/sport.webp' },
  { id: 'suitcase', src: '/assets/event_pics/suitcase.webp' },
  { id: 'travelling', src: '/assets/event_pics/travelling.webp' },
  { id: 'travelling2', src: '/assets/event_pics/travelling2.webp' },
  { id: 'trip-traveling', src: '/assets/event_pics/trip-travelling.webp' },
  { id: 'new', src: '/assets/event_pics/new.webp' }, 
  { id: 'coffee', src: '/assets/event_pics/coffee.webp' },
  { id: 'girls_club', src: '/assets/event_pics/girls_club.webp' }, 

  { id: 'vaultgrid', src: '/assets/event_pics/vaultgrid.webp', staffOnly: true },

  { id: 'vaultgrid-community-party', src: '/assets/event_pics/vaultgrid-community-party.webp', staffOnly: true },
  { id: 'summer-water-battle', src: '/assets/event_pics/summer-water-battle.webp', staffOnly: true },
  { id: 'badminton-rave', src: '/assets/event_pics/badminton-rave.webp', staffOnly: true },
  { id: 'new-joiners', src: '/assets/event_pics/new-joiners.webp', staffOnly: true },
  { id: 'clay-flower-workshop', src: '/assets/event_pics/clay-flower-workshop.webp', staffOnly: true },
  { id: 'sunshine-canvas-workshop', src: '/assets/event_pics/sunshine-canvas-workshop.webp', staffOnly: true },
  { id: 'creative-girls-night', src: '/assets/event_pics/creative-girls-night.webp', staffOnly: true },

  { id: 'trail-sneakers', src: '/assets/event_pics/trail-sneakers.webp' },
  { id: 'route-map', src: '/assets/event_pics/route-map.webp' },
  { id: 'compass', src: '/assets/event_pics/compass.webp' },
  { id: 'disco-ball', src: '/assets/event_pics/disco-ball.webp' },
  { id: 'dinner-table', src: '/assets/event_pics/dinner-table.webp' },
  { id: 'city-tour', src: '/assets/event_pics/city-tour.webp' },
  { id: 'coworking-table', src: '/assets/event_pics/coworking-table.webp' },
  { id: 'social-circle', src: '/assets/event_pics/social-circle.webp' },
  { id: 'darts', src: '/assets/event_pics/darts.webp' },
  { id: 'headphones', src: '/assets/event_pics/headphones.webp' },
  { id: 'poker-cards', src: '/assets/event_pics/poker-cards.webp' },
  { id: 'campfire', src: '/assets/event_pics/campfire.webp' },
  { id: 'sunrise-lines', src: '/assets/event_pics/sunrise-lines.webp' },
  { id: 'chat-bubbles', src: '/assets/event_pics/chat-bubbles.webp' },
  { id: 'brainstorm', src: '/assets/event_pics/brainstorm.webp' },
  { id: 'alpine-peak', src: '/assets/event_pics/alpine-peak.webp' },
  { id: 'city-bike', src: '/assets/event_pics/city-bike.webp' },
  { id: 'handshake', src: '/assets/event_pics/handshake.webp' },
  { id: 'entry-door', src: '/assets/event_pics/entry-door.webp' },
  { id: 'tennis-racket', src: '/assets/event_pics/tennis-racket.webp' },
  { id: 'travel-pack', src: '/assets/event_pics/travel-pack.webp' },
  { id: 'blue-cocktail', src: '/assets/event_pics/blue-cocktail.webp' },
  { id: 'espresso-cup', src: '/assets/event_pics/espresso-cup.webp' },
  { id: 'camp-tent', src: '/assets/event_pics/camp-tent.webp' },
  { id: 'running-shoe', src: '/assets/event_pics/running-shoe.webp' },
  { id: 'meetup-host', src: '/assets/event_pics/meetup-host.webp' },
  { id: 'music-notes', src: '/assets/event_pics/music-notes.webp' },
  { id: 'badminton', src: '/assets/event_pics/badminton.webp' },
  { id: 'volleyball-net', src: '/assets/event_pics/volleyball-net.webp' },
  { id: 'basketball-hoop', src: '/assets/event_pics/basketball-hoop.webp' },
  { id: 'soccer-goal', src: '/assets/event_pics/soccer-goal.webp' },
  { id: 'sound-speaker', src: '/assets/event_pics/sound-speaker.webp' },
  { id: 'map-pin-route', src: '/assets/event_pics/map-pin-route.webp' },
  { id: 'live-mic', src: '/assets/event_pics/live-mic.webp' },
  { id: 'skyline-drive', src: '/assets/event_pics/skyline-drive.webp' },
  { id: 'ribbon-bow', src: '/assets/event_pics/ribbon-bow.webp' },
  { id: 'party-garland', src: '/assets/event_pics/party-garland.webp' },
  { id: 'floor-stretch', src: '/assets/event_pics/floor-stretch.webp' },
  { id: 'lucky-dice', src: '/assets/event_pics/lucky-dice.webp' },
  { id: 'tango-step', src: '/assets/event_pics/tango-step.webp' },
  { id: 'cinema-reel', src: '/assets/event_pics/cinema-reel.webp' },
  { id: 'bowling', src: '/assets/event_pics/bowling.webp' },
  { id: 'clinking-glasses', src: '/assets/event_pics/clinking-glasses.webp' },
  { id: 'skyline-breeze', src: '/assets/event_pics/skyline-breeze.webp' },
  { id: 'music-headset', src: '/assets/event_pics/music-headset.webp' },
  { id: 'beach-chair', src: '/assets/event_pics/beach-chair.webp' },
  { id: 'picnic-basket', src: '/assets/event_pics/picnic-basket.webp' },
  { id: 'artist-palette', src: '/assets/event_pics/artist-palette.webp' },
  { id: 'croissant-coffee', src: '/assets/event_pics/croissant-coffee.webp' },
  { id: 'question-card', src: '/assets/event_pics/question-card.webp' },
  { id: 'globe-chat', src: '/assets/event_pics/globe-chat.webp' },
  { id: 'neon-disco-night', src: '/assets/event_pics/neon-disco-night.webp' },
  { id: 'cozy-card-night', src: '/assets/event_pics/cozy-card-night.webp' },
  { id: 'park-yoga-session', src: '/assets/event_pics/park-yoga-session.webp' },
  { id: 'cozy-book-club', src: '/assets/event_pics/cozy-book-club.webp' },
  { id: 'alpine-trail', src: '/assets/event_pics/alpine-trail.webp' },
  { id: 'classic-darts', src: '/assets/event_pics/classic-darts.webp' },
  { id: 'forest-hiking-duo', src: '/assets/event_pics/forest-hiking-duo.webp' },
  { id: 'lawn-tennis', src: '/assets/event_pics/lawn-tennis.webp' },
  { id: 'garden-picnic-party', src: '/assets/event_pics/garden-picnic-party.webp' },
  { id: 'movie-night', src: '/assets/event_pics/movie-night.webp' },
  { id: 'forest-campfire', src: '/assets/event_pics/forest-campfire.webp' },
  { id: 'park-cycling', src: '/assets/event_pics/park-cycling.webp' },
  { id: 'grass-volleyball', src: '/assets/event_pics/grass-volleyball.webp' },
  { id: 'track-running', src: '/assets/event_pics/track-running.webp' },
  { id: 'lawn-badminton', src: '/assets/event_pics/lawn-badminton.webp' },
  { id: 'grass-basketball', src: '/assets/event_pics/grass-basketball.webp' },
  { id: 'bowling-night', src: '/assets/event_pics/bowling-night.webp' },
  { id: 'park-dance', src: '/assets/event_pics/park-dance.webp' },
  { id: 'go-karting', src: '/assets/event_pics/go-karting.webp' },
  { id: 'coffee-break', src: '/assets/event_pics/coffee-break.webp' },
  { id: 'grass-football', src: '/assets/event_pics/grass-football.webp' },
  { id: 'open-air-festival', src: '/assets/event_pics/open-air-festival.webp' },
  { id: 'park-frisbee', src: '/assets/event_pics/park-frisbee.webp' },
  { id: 'girls-party', src: '/assets/event_pics/girls-party.webp' },
  { id: 'group-gym-workout', src: '/assets/event_pics/group-gym-workout.webp' },
  { id: 'park-painting', src: '/assets/event_pics/park-painting.webp' },
  { id: 'sunset-roller-skating', src: '/assets/event_pics/sunset-roller-skating.webp' },
  { id: 'sunset-lookout', src: '/assets/event_pics/sunset-lookout.webp' },
  { id: 'beach-day', src: '/assets/event_pics/beach-day.webp' },
  { id: 'adventure-backpack', src: '/assets/event_pics/adventure-backpack.webp' },
  { id: 'dancing-night', src: '/assets/event_pics/dancing-night.webp' },
  { id: 'choir-singing', src: '/assets/event_pics/choir-singing.webp' },
];
